import CustomTable from 'components/layouts/CustomTable';
import React from 'react';

const tableData = [
  {
    sn: 1,
    amount: 5000,
    status: 'PENDING',
    plan: 'STARTER',
    crypto: 'BITCOIN',
    transactionId: '256ffYf51WE',
    trxType: 'DEPOSIT',
  },
  {
    sn: 2,
    amount: 1000,
    status: 'PENDING',
    crypto: 'BNB',
    transactionId: '256ffYf51WE',
    trxType: 'WITHDRAWAL',
  },
  {
    sn: 3,
    amount: 5000,
    status: 'PENDING',
    plan: 'STARTER',
    crypto: 'BITCOIN',
    transactionId: '256ffYf51WE',
    trxType: 'DEPOSIT',
  },
  {
    sn: 4,
    amount: 50000,
    status: 'PENDING',
    plan: 'GOLD',
    crypto: 'ETHEREUM',
    transactionId: '256ffYf51WE',
    trxType: 'DEPOSIT',
  },
  {
    sn: 5,
    amount: 50000,
    status: 'PENDING',
    crypto: 'ETHEREUM',
    transactionId: '256ffYf51WE',
    trxType: 'WITHDRAWAL',
  },
  {
    sn: 6,
    amount: 2000,
    status: 'PENDING',
    plan: 'STANDARD',
    crypto: 'ETHEREUM',
    transactionId: '256ffYf51WE',
    trxType: 'DEPOSIT',
  },
  {
    sn: 7,
    amount: 200,
    status: 'CONFIRMED',
    plan: 'STARTER',
    crypto: 'ETHEREUM',
    transactionId: '256ffYf51WE',
    trxType: 'DEPOSIT',
  },
  {
    sn: 8,
    amount: 1000,
    status: 'PENDING',
    crypto: 'USDT',
    transactionId: '256ffYf51WE',
    trxType: 'WITHDRAWAL',
  },
  {
    sn: 9,
    amount: 8000,
    status: 'CONFIRMED',
    plan: 'PREMIUM',
    crypto: 'BNB',
    transactionId: '256ffYf51WE',
    trxType: 'DEPOSIT',
  },
  {
    sn: 10,
    amount: 12000,
    status: 'CONFIRMED',
    crypto: 'BITCOIN',
    transactionId: '256ffYf51WE',
    trxType: 'WITHDRAWAL',
  },
];

type ColumnShape = {
  row: { original: (typeof tableData)[number] };
};

const columns = [
  {
    Header: 'S/N',
    accessor: 'sn',
    Cell: ({ row: { original } }: ColumnShape) => {
      const { sn } = original;
      return <p>{sn}</p>;
    },
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    Cell: ({ row: { original } }: ColumnShape) => {
      const { amount } = original;
      return <small>{amount}</small>;
    },
  },
  {
    Header: 'Plan',
    accessor: 'plan',
    Cell: ({ row: { original } }: ColumnShape) => {
      const { plan } = original;
      return <small>{plan ?? 'NaN'}</small>;
    },
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row: { original } }: ColumnShape) => {
      const { status } = original;
      return <small>{status}</small>;
    },
  },
  {
    Header: 'Crypto',
    accessor: 'crypto',
    Cell: ({ row: { original } }: ColumnShape) => {
      const { crypto } = original;
      return <small>{crypto}</small>;
    },
  },
  {
    Header: 'Trx Type',
    accessor: 'trxType',
    Cell: ({ row: { original } }: ColumnShape) => {
      const { trxType } = original;
      return <small>{trxType}</small>;
    },
  },
];

interface TransactionProps {
  text?: string;
  hidePagination?: boolean;
  data?: typeof tableData;
  size: number;
  containerClass?: string;
}

const Transaction = ({
  text,
  hidePagination = true,
  data = [],
  size,
  containerClass,
}: TransactionProps) => {
  return (
    <div className={containerClass}>
      {text && <p className="text-xl font-medium">{text}</p>}
      <CustomTable
        columnShape={columns}
        data={data}
        hidePagination={hidePagination}
        size={size}
      />
    </div>
  );
};

export default Transaction;
